import React, { Component } from 'react';
import {Button, Row, Col} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import API from '../../../../services/API';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';


class Default extends Component {
    constructor(props) {
        super(props);

        this.state = {
            base: '',
            weekend: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);

    }

    componentDidMount() {
        this.load();
    }

    load() {
        this.props.setLoading('DEFAULT');
        API.PcCutoff.getDefault().then(({ cutoffs }) => {
            const stateUpdates = cutoffs.reduce((obj, row) => {
                obj[row.type] = row.cutoff;

                return obj;
            }, {});

            this.setState(stateUpdates);
            this.props.setLoaded('DEFAULT');
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.setLoading('DEFAULT_SAVE');

        Promise.all([
            API.PcCutoff.saveDefault('base', this.state.base),
            API.PcCutoff.saveDefault('weekend', this.state.weekend)
        ]).then(() => this.props.setLoaded('DEFAULT_SAVE'));
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>

                <Row>
                    <Col lg={5}>
                        <FieldGroup
                            name="base"
                            label="Base:"
                            onChange={this.handleFieldChange}
                            value={this.state.base}
                            type={'number'}
                            step={'0.01'}
                            min={'0'}
                            max={'100'}
                            required
                        />
                    </Col>
                    <Col lg={5}>
                        <FieldGroup
                            name="weekend"
                            label="Weekend:"
                            onChange={this.handleFieldChange}
                            value={this.state.weekend}
                            type={'number'}
                            step={'0.01'}
                            min={'0'}
                            max={'100'}
                            required
                        />
                    </Col>
                </Row>
                <Button bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
            </form>
        );
    }
}

export default Default;


// WEBPACK FOOTER //
// ./src/scenes/PcCutoff/components/Default/index.js